var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cgx } from "@springcare/dsm";
import { isVerdantColorScheme } from "../../utils/guards";
import { VerdantColorSchemes } from "../../index";
export var linkTheme = {
    variants: {
        "v-medium-emphasis": function (_a) {
            var colorScheme = _a.colorScheme, isDisabled = _a.isDisabled;
            if (isDisabled)
                return {
                    textUnderlinePosition: "under",
                    textDecorationThickness: "1px",
                    textDecor: "underline",
                    color: "content-disabled",
                    pointerEvents: "none",
                };
            var isColorScheme = isVerdantColorScheme(colorScheme);
            if (isColorScheme) {
                var interactive_1 = {
                    color: "hover-".concat(colorScheme, "-high-emphasis"),
                    textDecorationThickness: "1px",
                };
                return {
                    textUnderlinePosition: "under",
                    textDecorationThickness: "1px",
                    textDecor: "underline",
                    color: colorScheme === VerdantColorSchemes.warning
                        ? "warning-bold"
                        : "".concat(colorScheme, "-base"),
                    _hover: interactive_1,
                    _active: interactive_1,
                    _focus: interactive_1,
                };
            }
            var interactive = {
                color: "hover-base-high-emphasis",
                textDecorationThickness: "1px",
            };
            return {
                textUnderlinePosition: "under",
                textDecorationThickness: "1px",
                textDecor: "underline",
                color: "primary-base",
                _hover: interactive,
                _active: interactive,
                _focus: interactive,
            };
        },
    },
    sizes: {
        "v-sm": __assign({}, cgx.textStyles["body-small-strong"]),
        "v-md": __assign({}, cgx.textStyles["body-medium-strong"]),
    },
    defaultProps: {
        size: "v-md",
        variant: "v-medium-emphasis",
    },
};
